export const AttachmentType = Object.freeze({
    "Eoi": 1,
    "DpAffidavit": 2,
    "ProofOfDisability": 3,
    "SpouseEoi": 4
})